<button
        mat-icon-button
        class="clickable"
        *ngIf="show"
        [disabled]="takingAction"
        [matTooltip]="toolTip"
        (click)="onClick()">
    <mat-icon [color]="color">{{action.icon}}</mat-icon>
    <mat-progress-spinner
        *ngIf="takingAction"
        mode="indeterminate"
        color="primary"
        diameter="30"></mat-progress-spinner>
</button>